import React, { useState, useEffect } from 'react';
import { Filter, Save } from 'lucide-react';
import '../styles/Dashboard.css';
import Modal from './ui/Modal';

const TeamsFilterModal = ({ 
  isOpen, 
  onClose, 
  onSave, 
  currentSettings = {}, 
  loading = false 
}) => {
  const [filterSettings, setFilterSettings] = useState({
    hideReadMessages: false,
    hoursFilter: 0, // 0 = disabled
    enableHoursFilter: false,
    ...currentSettings
  });
  
  const [keywordsList, setKeywordsList] = useState('');

  useEffect(() => {
    if (isOpen && currentSettings) {
      setFilterSettings({
        hideReadMessages: currentSettings.hideReadMessages || false,
        hoursFilter: currentSettings.hoursFilter || 24,
        enableHoursFilter: currentSettings.enableHoursFilter || false,
        ...currentSettings
      });
      setKeywordsList(currentSettings.keywords || '');
    }
  }, [isOpen, currentSettings]);

  const handleSave = () => {
    const settings = {
      ...filterSettings,
      keywords: keywordsList
    };
    onSave(settings);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      icon={<Filter size={24} />}
      title="Teams-Nachrichten Filter konfigurieren"
      closeDisabled={loading}
      footer={(
        <>
          <button
            type="button"
            onClick={onClose}
            className="btn btn-secondary"
            disabled={loading}
          >
            Abbrechen
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="btn btn-primary"
            disabled={loading}
          >
            <Save size={16} />
            {loading ? 'Speichern...' : 'Speichern'}
          </button>
        </>
      )}
    >
      <div className="form-body">
          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={filterSettings.hideReadMessages}
                onChange={(e) => setFilterSettings({
                  ...filterSettings,
                  hideReadMessages: e.target.checked
                })}
                disabled={loading}
              />
              <span className="checkmark"></span>
              Gelesene Teams-Nachrichten ausblenden
            </label>
            <small className="form-help">
              Wenn aktiviert, werden bereits gelesene Teams-Nachrichten in der Liste nicht angezeigt.
            </small>
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={filterSettings.enableHoursFilter}
                onChange={(e) => setFilterSettings({
                  ...filterSettings,
                  enableHoursFilter: e.target.checked
                })}
                disabled={loading}
              />
              <span className="checkmark"></span>
              Nur Teams-Nachrichten aus den letzten Stunden anzeigen
            </label>
            
            {filterSettings.enableHoursFilter && (
              <div className="hours-filter-container" style={{ marginTop: '10px', marginLeft: '30px' }}>
                <label htmlFor="hours-input">Anzahl Stunden:</label>
                <input
                  id="hours-input"
                  type="number"
                  min="1"
                  max="168" // 7 Tage
                  value={filterSettings.hoursFilter}
                  onChange={(e) => setFilterSettings({
                    ...filterSettings,
                    hoursFilter: parseInt(e.target.value) || 1
                  })}
                  className="form-input"
                  style={{ width: '80px', marginLeft: '10px' }}
                  disabled={loading}
                />
                <small className="form-help" style={{ display: 'block', marginTop: '5px' }}>
                  Zeigt nur Teams-Nachrichten aus den letzten {filterSettings.hoursFilter} Stunden an.
                </small>
              </div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="keywords-list">Schlagwort-Filter</label>
            <textarea
              id="keywords-list"
              value={keywordsList}
              onChange={(e) => setKeywordsList(e.target.value)}
              placeholder="Ein Schlagwort pro Zeile eingeben...&#10;z.B.:&#10;john.doe@company.com&#10;Projekt Alpha&#10;Marketing Team"
              rows="8"
              className="form-textarea"
              disabled={loading}
            />
            <small className="form-help">
              Teams-Nachrichten, die diese Schlagwörter im Absender ("Von") oder Chat-Namen enthalten, werden herausgefiltert. 
              Ein Schlagwort pro Zeile eingeben.
            </small>
          </div>

          <div className="form-group">
            <div className="filter-preview">
              <h4>Aktive Filter:</h4>
              <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                {filterSettings.hideReadMessages && (
                  <li>Gelesene Teams-Nachrichten werden ausgeblendet</li>
                )}
                {filterSettings.enableHoursFilter && (
                  <li>Nur Teams-Nachrichten aus den letzten {filterSettings.hoursFilter} Stunden</li>
                )}
                {keywordsList.trim() && (
                  <li>
                    {keywordsList.split('\n').filter(k => k.trim()).length} Schlagwort(e) werden gefiltert
                  </li>
                )}
                {!filterSettings.hideReadMessages && !filterSettings.enableHoursFilter && !keywordsList.trim() && (
                  <li style={{ color: 'var(--color-text-placeholder)' }}>Keine Filter aktiv</li>
                )}
              </ul>
            </div>
          </div>
        </div>
    </Modal>
  );
};

export default TeamsFilterModal;